import PrestationsTab from "@features/creation/prestations/components/PrestationsTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Tag } from "lucide-react";

export const Route = createFileRoute("/_app/creation/prestations/")({
  loader: requirePermission(PERMISSIONS.CREATION.PRESTATIONS.VIEW),
  staticData: {
    title: "Prestations",
    icon: Tag,
    tab_icon: Tag,
    permission: PERMISSIONS.CREATION.PRESTATIONS.VIEW,
    module: "creation",
    section: "Creation",
    order: 25,
    description: "Gestion des prestations",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: PrestationsTab,
});
